import { createContext, useContext } from 'react';

import {
  TGroupShellConfig,
  TGroupShellConfigProviderProps,
} from '@/shared/features/groups/components/group-list/group-shell-context.types';

const GroupShellContext = createContext<TGroupShellConfig | null>(null);

export const GroupShellConfigProvider = ({
  value,
  children,
}: TGroupShellConfigProviderProps) => (
  <GroupShellContext.Provider value={value}>
    {children}
  </GroupShellContext.Provider>
);

export const useGroupShellConfig = (): TGroupShellConfig => {
  const config = useContext(GroupShellContext);

  if (!config) {
    throw new Error(
      'useGroupShellConfig must be used within a GroupShellConfigProvider',
    );
  }

  return config;
};
